import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "add-circle" }),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12,
			y1: 7.5,
			x2: 12,
			y2: 16.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 7.5,
			y1: 12,
			x2: 16.5,
			y2: 12
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 12,
			cy: 12,
			r: 11.25
		})
	]
});
export default SvgAddCircle;
